<script lang="ts">
	import { onMount } from 'svelte'
	export let src: string | undefined
	export let alt: string

	let current_src = src
	let image_loader: HTMLImageElement | null = null

	onMount(() => {
		image_loader = new Image()

		image_loader.onload = () => {
			current_src = src
		}
	})

	function load_new_image(src: string) {
		if (image_loader) {
			image_loader.src = src
		}
	}

	$: src && src !== current_src && load_new_image(src)

	$: loading = src !== current_src
</script>

<img
	data-loading={loading}
	src={current_src}
	{alt}
	{...$$restProps}
/>

<style>
	img{
		opacity: 1;
		transition: opacity .1s ;
	}
	img[data-loading=true] {
		opacity: 0.6;
	}
</style>
